import React from "react";

export const PERIODS = [
  { k: "all", zh: "累计", en: "All time" },
  { k: "week", zh: "本周", en: "This week" },
  { k: "month", zh: "本月", en: "This month" },
  { k: "quarter", zh: "本季度", en: "This quarter" },
  { k: "year", zh: "本年", en: "This year" },
];
export const periodLabel = (k, zh) => { const p = PERIODS.find((x) => x.k === k) || PERIODS[0]; return zh ? p.zh : p.en; };
export const prevLabel = (k, zh) => ({ week: zh ? "较上周" : "vs last week", month: zh ? "较上月" : "vs last month", quarter: zh ? "较上季" : "vs last quarter", year: zh ? "较去年同期" : "vs last year" }[k] || (zh ? "回款环比" : "MoM"));

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
/* 本周 / 本月 / 本季度 / 本年 → { start, end }（YYYY-MM-DD，本地日期）；累计 → null */
export function periodRange(k, today = new Date()) {
  if (!["week", "month", "quarter", "year"].includes(k)) return null;
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  let s;
  if (k === "week") { s = new Date(t); s.setDate(t.getDate() - ((t.getDay() + 6) % 7)); }
  else if (k === "month") s = new Date(t.getFullYear(), t.getMonth(), 1);
  else if (k === "quarter") s = new Date(t.getFullYear(), Math.floor(t.getMonth() / 3) * 3, 1);
  else s = new Date(t.getFullYear(), 0, 1);
  return { start: iso(s), end: iso(t) };
}
export const inPeriod = (dateStr, range) => { const d = String(dateStr || "").slice(0, 10); return !range || (!!d && d >= range.start && d <= range.end); };

/* 时间范围切换：累计 / 本周 / 本月 / 本季度 / 本年 */
export function PeriodPicker({ value, onChange, zh, testid = "period-picker" }) {
  return (
    <div className="inline-flex items-center gap-0.5 bg-slate-100 rounded-lg p-0.5" data-testid={testid} data-value={value}>
      {PERIODS.map((p) => (
        <button key={p.k} type="button" data-testid={`${testid}-${p.k}`} onClick={() => onChange(p.k)}
          className={`px-2.5 py-1 text-xs font-medium rounded-md transition-colors ${value === p.k ? "bg-white text-red-600 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}>
          {zh ? p.zh : p.en}
        </button>
      ))}
    </div>
  );
}
